import React from 'react';
import {
  IconSizes,
  AlertCircleIcon,
  ClockIcon,
  Phone2Icon,
} from '@newcore/icons';
import { Button } from '@newcore/ui/buttons';
import { Sizes } from '@newcore/ui/enums/sizes';
import { StatusContainer } from '@/components/ui/status-container';
import { useLanguage } from '@/contexts/language-context';
import { StatusVariant } from '@/enums/status-variant';
import { makeFullPath } from '@/utils/path-utils';

interface PushNotificationPollingErrorStateProps {
  errorMessage: string;
  retry: () => void;
}

export const PushNotificationPollingErrorState: React.FC<
  PushNotificationPollingErrorStateProps
> = ({ errorMessage, retry }) => {
  const { t } = useLanguage();

  const isExpiredError = errorMessage.includes('expired');
  const isNoDeviceError =
    errorMessage.includes('no device') || errorMessage.includes('No device');

  let title = t('mfa.error');
  let message = errorMessage ?? t('mfa.genericError');
  let icon = <AlertCircleIcon size={IconSizes.LG} strokeWidth={2.25} />;

  if (isExpiredError) {
    title = t('mfa.expired');
    message = t('mfa.requestExpired');
    icon = <ClockIcon size={IconSizes.LG} strokeWidth={2.25} />;
  } else if (isNoDeviceError) {
    title = t('mfa.noDeviceRegistered');
    message = t('mfa.noDeviceMessage');
    icon = <Phone2Icon size={IconSizes.LG} strokeWidth={2.25} />;
  }

  return (
    <StatusContainer
      variant={StatusVariant.ERROR}
      title={title}
      message={message}
      icon={icon}
    >
      {!isExpiredError && !isNoDeviceError && (
        <Button
          type='button'
          size={Sizes.MD}
          onClick={retry}
          className='w-full'
        >
          {t('common.retry')}
        </Button>
      )}

      {isExpiredError && (
        <Button
          type='button'
          size={Sizes.MD}
          onClick={() => {
            window.location.href = makeFullPath('/login');
          }}
          className='w-full'
        >
          {t('common.retry')}
        </Button>
      )}

      {isNoDeviceError && (
        <p className='text-center text-secondary'>
          {t('mfa.registerDeviceHint')}
        </p>
      )}
    </StatusContainer>
  );
};
